import { useLocation } from "react-router-dom"

export const useId = () => {
  const location = useLocation()
  const parts = location.pathname.split('/')
  return parts[parts.length - 2]
}
